<div class="initial-icon" style="background-color: {{ color }};">
  {{ initial }}
</div>
